import React, {Component} from 'react';
import { graphql } from 'gatsby';
import ComponentsManager from "../../utils/components-manager";


/**
 * This components renders hero
 */
export default class FixedContent extends Component {

    /**
     * Constuct components manager
     * @param props
     */
    constructor(props)
	{
        super(props);
        this.data = props;
    }


    /**
     * Render menu
     * @returns {*}
     */
    render()
    {
        const wideMode = this.props.field_enable_wide_view_mode
        return (
            <section className={ wideMode? "container wide" : "container"} role="main">
                <div className="row">
                  <div className={ wideMode? "p-3 p-sm-0" : "col-lg-8 offset-lg-2 offset-xl-2"}>
                    <div className="inner-page fixed-content">
                      <ComponentsManager components={this.data.relationships.field_items} />
                    </div>
                  </div>
                </div>
            </section>
        )
    }
};

export const FixedContentQuery = graphql`
fragment ParagraphsFixedContent on paragraph__fixed_content {
  field_enable_wide_view_mode
  relationships {
    field_items {
      __typename
      ... on Node {
        ...ParagraphsPlainAreaText
        ...ParagraphsMediaWithCaption
        ...ParagraphsVideo
        ...ParagraphsQuoteStatement
        
        ...ParagraphsAccordion
        ...ParagraphsResources
        
        ...ParagraphsYourChecklist

        ...ParagraphHowItWorks
        ...ParagraphsVideoAndText
        ...ParagraphsThreeCardsBlueGradient
	...ParagraphsSingleCardGradientBorder
        ...ParagraphsSingleCardGradientBorderB
        ...ParagraphsTwoCardsGradientBorder
        ...ParagraphComponentIntro
        ...ParagraphTextCtaImage
        ...ParagraphsBluePhotoBanner
        ...ParagraphsTermBox
        ...ParagraphsTipBox
        ...ParagraphNewsletterSignup
        ...ParagraphsContactForm
        ...ParagraphsBlueBackgroundText
        ...ParagraphsDownloadableContent
        ...ParagraphsPurpleCards
      } 
    }
  }
}
`;
